import { useEffect, useState } from "react";
import userTranslationsHelper from "../../../../../languages/user-translations.helper";
import orderDetailsForwardingAvailableConsumerFactory from "./types/order-details-forwarding-available-consumer.factory";
import OrderDetailsForwardingAvailableConsumerSelectOption from "./types/order-details-forwarding-available-consumer-select-option";
import SelectOption from "../../../../../common/components/form/select/common/option/select-option";
import SingleSelectComponent from "../../../../../common/components/form/select/single-select/single-select.component";
import useAbort from "../../../../../common/hooks/use-abort";
import OrderTransportingOrderAvailableConsumersParams from "../../../../../common/services/order/transporting-order/available-consumers/order-transporting-order-available-consumers-params";
import useOrderTransportingOrderAvailableConsumers from "../../../../../common/services/order/transporting-order/available-consumers/use-order-transporting-order-available-consumers";

type OrderDetailsSelectAvailableConsumerComponentProps = {
  forwardingId?: string | undefined;
  selectedTaxiCorporationValue: SelectOption | null;
  transportingOrderId: string | null;
  onChange: (
    newValue: OrderDetailsForwardingAvailableConsumerSelectOption,
  ) => void;
};

const OrderDetailsSelectAvailableConsumerComponent = (
  props: OrderDetailsSelectAvailableConsumerComponentProps,
) => {
  const [taxiCorporationSelectOptions, setTaxiCorporationSelectOptions] =
    useState<OrderDetailsForwardingAvailableConsumerSelectOption[]>([]);
  const translations =
    userTranslationsHelper.getTaxiOfficerListingTranslations().select;

  const transportingOrderAvailableConsumers =
    useOrderTransportingOrderAvailableConsumers();
  const transportingOrderAvailableConsumersAbort = useAbort();

  const loadTransportingOrderAvailableConsumers = (
    transportingOrderId: string,
  ) => {
    const loadParams: OrderTransportingOrderAvailableConsumersParams = {
      transportingOrderUuid: transportingOrderId!,
    };

    transportingOrderAvailableConsumers.load(
      loadParams,
      transportingOrderAvailableConsumersAbort.signal,
    );
  };

  useEffect(() => {
    if (!props.transportingOrderId) {
      return;
    }

    loadTransportingOrderAvailableConsumers(props.transportingOrderId);

    return transportingOrderAvailableConsumersAbort.revoke;
  }, [props.transportingOrderId]);

  useEffect(() => {
    const taxiAvailableConsumersSelectOptions =
      orderDetailsForwardingAvailableConsumerFactory.createSelectOptions(
        transportingOrderAvailableConsumers.data,
      );

    setTaxiCorporationSelectOptions(taxiAvailableConsumersSelectOptions);
  }, [transportingOrderAvailableConsumers.data]);

  return (
    <SingleSelectComponent
      placeholder={translations.selectTaxiCorporationPlaceholder}
      value={props.selectedTaxiCorporationValue!}
      onChange={(value) => props.onChange(value!)}
      options={taxiCorporationSelectOptions}
      isLoading={transportingOrderAvailableConsumers.isLoading}
      isSearchable
      menuPlacement="bottom"
      menuPosition="fixed"
    />
  );
};

export default OrderDetailsSelectAvailableConsumerComponent;
